var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgB1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.996,
    height: 19.997,
    viewBox: "0 0 19.996 19.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_809",
    "data-name": "Rectangle 809",
    width: 19.996,
    height: 19.997,
    transform: "translate(0 0)",
    fill: "#ff5150"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4244",
    "data-name": "Path 4244",
    d: "M6.815,7.488a.674.674,0,1,0-.673-.673.673.673,0,0,0,.673.673",
    fill: "#ff5150"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4245",
    "data-name": "Path 4245",
    d: "M13.167,12.492a.675.675,0,1,0,.675.675.675.675,0,0,0-.675-.675",
    fill: "#ff5150"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4246",
    "data-name": "Path 4246",
    d: "M19.056,7.732l-.7-.7a1.2,1.2,0,0,1-.35-.845v-1a3.2,3.2,0,0,0-3.2-3.2h-1a1.2,1.2,0,0,1-.845-.347l-.71-.71A3.33,3.33,0,0,0,9.99,0,3.179,3.179,0,0,0,7.732.942l-.7.7a1.192,1.192,0,0,1-.845.349h-1a3.2,3.2,0,0,0-3.2,3.2v1a1.194,1.194,0,0,1-.348.844l-.71.711a3.2,3.2,0,0,0,.011,4.523l.7.7a1.2,1.2,0,0,1,.349.845v1a3.2,3.2,0,0,0,3.2,3.2h1a1.2,1.2,0,0,1,.845.347l.711.711a3.2,3.2,0,0,0,4.524-.01l.7-.7a1.2,1.2,0,0,1,.846-.349h1a3.2,3.2,0,0,0,3.2-3.2v-1a1.192,1.192,0,0,1,.348-.844l.711-.711a3.2,3.2,0,0,0-.011-4.524M4.8,6.815a2.02,2.02,0,1,1,2.02,2.02A2.022,2.022,0,0,1,4.8,6.815m2.548,7.451a1.154,1.154,0,0,1-1.631-1.632l6.922-6.921a1.153,1.153,0,1,1,1.631,1.631Zm5.824.926a2.025,2.025,0,1,1,2.025-2.025,2.027,2.027,0,0,1-2.025,2.025",
    fill: "#ff5150"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgB1);
export default __webpack_public_path__ + "static/media/b1.095f740635cbfb99dfe9b79fb8a22532.svg";
export { ForwardRef as ReactComponent };